import * as React from 'react';
import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const inputVariants = cva(
  cn(
    'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2',
    'text-base ring-offset-background',
    'file:border-0 file:bg-transparent file:text-sm file:font-medium',
    'file:text-foreground',
    'placeholder:text-muted-foreground',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
    'focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
    'md:text-sm',
  ),
  {
    variants: {
      error: {
        true: 'border-destructive',
        false: '',
      },
      'color-picker': {
        true: cn(
          'p-0',
          'appearance-none w-10 border-none cursor-pointer bg-transparent',
          '[&::-webkit-color-swatch]:rounded-md [&::-webkit-color-swatch]:border [&::-webkit-color-swatch]:border-input',
          '[&::-moz-color-swatch]:rounded-md [&::-moz-color-swatch]:border [&::-moz-color-swatch]:border-input',
        ),
        false: '',
      },
    },
    defaultVariants: {
      error: false,
      'color-picker': false,
    },
  },
);

export interface InputProps
  extends React.ComponentProps<'input'>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, 'color-picker': colorPicker, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        inputVariants({
          error,
          'color-picker': colorPicker || type === 'color',
          className,
        }),
      )}
      ref={ref}
      {...props}
    />
  ),
);

Input.displayName = 'Input';

export { Input };
